import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, Separator, Spinner } from 'telia-front-react';
import Config from '../Config';
import NotFound from '../notfound/NotFound';
import ContentStore, { CONTENT_EDIT_LOCAL_STORAGE_KEY, PageContent } from '../stores/ContentStore';
import GaDataStore from '../stores/GaDataStore';
import LanguageStore from '../stores/LanguageStore';
import ContentPageOverlay from './ContentPageOverlay';
import JsxRenderer from './JsxRenderer';
import NewsDetailsContainer from './NewsDetailsContainer';

interface ContentPageProps {
  contentStore?: ContentStore;
  languageStore?: LanguageStore;
  gaDataStore?: GaDataStore;
  isNode?: boolean;
}

@observer
class ContentPage extends React.Component<ContentPageProps> {
  public componentDidUpdate() {
    const contentStore = this.props.contentStore;
    const contentPageEl = document.getElementById('contentPage');
    if (contentStore.isFetched && contentPageEl) {
      contentStore.setCurrentContentHeight(contentPageEl.clientHeight);
    }
  }

  public componentWillUnmount() {
    this.props.contentStore.setCurrentContentHeight(null);
  }

  private loadingStyle() {
    const currentContentHeight = this.props.contentStore.currentContentHeight;
    return currentContentHeight ? { height: currentContentHeight } : {};
  }

  private renderPageEditButtonIfNeeded = (currentContent: PageContent) => {
    const { languageStore, isNode } = this.props;

    return !isNode && Config.env !== 'local' && localStorage.getItem(CONTENT_EDIT_LOCAL_STORAGE_KEY) === 'true' ? (
      <Separator spacing="medium">
        <Button
          type="employee"
          text="Muuda lehte"
          size="small"
          target={'_blank'}
          url={`https://wpcms${Config.env !== 'live' ? `-${Config.env}` : ''}.telia.ee/telia/wp-admin/post.php?post=${currentContent.id}&action=edit&lang=${
            languageStore.currentLanguage
          }`}
          iconRight="#edit"
        />
      </Separator>
    ) : null;
  };

  public render() {
    const { contentStore } = this.props;
    const currentContent = contentStore.currentPageContent;
    if (contentStore.isFetching) {
      return (
        <div id="loadingContentPage" style={this.loadingStyle()}>
          <Spinner />
        </div>
      );
    }
    if (contentStore.notFound) {
      return <NotFound />;
    }
    switch (currentContent.type) {
      case 'post':
        return (
          <div id="contentPage">
            <NewsDetailsContainer title={currentContent.title} displayDate={currentContent.date} tags={currentContent.tags}>
              <JsxRenderer jsx={currentContent.content} showErrorNotice={true} />
            </NewsDetailsContainer>
            {this.renderPageEditButtonIfNeeded(currentContent)}
          </div>
        );
      default:
        return (
          <div id="contentPage" data-swiftype-name="body" data-swiftype-type="text">
            <JsxRenderer jsx={currentContent.content} showErrorNotice={true} />
            <ContentPageOverlay />
            {this.renderPageEditButtonIfNeeded(currentContent)}
          </div>
        );
    }
  }
}

export default inject('contentStore', 'languageStore', 'gaDataStore', 'isNode')(ContentPage);
